import { useCallback, useEffect, useState } from 'react';
import api from '../api/api';
import Header from '../components/Header';
import Footer from '../components/Footer';


export default function NatureList() {
  const [natures, setNatures] = useState([]);
  const [editId, setEditId] = useState(null);
  const [libelle, setLibelle] = useState('');
  const token = localStorage.getItem('token');

  const loadNatures = useCallback(async () => {
    try {
      const res = await api.get('/natures', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setNatures(res.data);
    } catch (err) {
      console.error('Erreur chargement natures:', err);
    }
  }, [token]);

  useEffect(() => {
    loadNatures();
  }, [loadNatures]);

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cette nature ?')) return;

    try {
      await api.delete(`/natures/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      loadNatures();
    } catch (err) {
      if (err.response && err.response.status === 409) {
        // Affiche le message du middleware : "Vous ne pouvez pas supprimer cette application..." 
        // Note : Vous pouvez adapter le message du middleware dans app.js pour qu'il soit plus générique
        alert(err.response.data.message);
      } else {
        alert('Erreur : impossible de supprimer cette nature.');
        console.error(err);
      }
    }
  };

  const handleEdit = (n) => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    setEditId(n.id);
    setLibelle(n.libelle);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await api.put(
          `/natures/${editId}`,
          { libelle },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setEditId(null);
      } else {
        await api.post(
          '/natures',
          { libelle },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      setLibelle('');
      loadNatures();
    } catch (err) {
      alert("Erreur lors de l'enregistrement.");
    }
  };

  return (
    <>
      <Header />
      <main className="container">
        <h2>Natures d’interruption</h2>

        <form onSubmit={handleSubmit}>
          <input
            placeholder="Libellé"
            value={libelle}
            onChange={(e) => setLibelle(e.target.value)}
            required
          />
          <button type="submit">{editId ? 'Modifier' : 'Ajouter'}</button>
          {editId && (
            <button
              type="button"
              onClick={() => {
                setEditId(null);
                setLibelle('');
              }}
            >
              Annuler
            </button>
          )}
        </form>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Libellé</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {natures.map((n) => (
                <tr key={n.id}>
                  <td>{n.id}</td>
                  <td>{n.libelle}</td>
                  <td>
                    <button onClick={() => handleEdit(n)}>✏️</button>
                    <button onClick={() => handleDelete(n.id)}>🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
      <Footer />
    </>
  );
}